import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Connector from "./connector";
import BasicExample from "./texting";
import Port from "./port";
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap/dist/js/bootstrap'
// import  $ from 'jquery'
// import Popper from "popper.js";
 


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Connector />
  </React.StrictMode>
);
